module.exports = __webpack_public_path__ + "img/ic_wallet.00ad0d8c.svg";